import { Phone } from "lucide-react";
import React from "react";
import { BsTwitterX } from "react-icons/bs";
import { FaFacebookF, FaInstagram, FaLinkedinIn } from "react-icons/fa";
import { Link } from "react-router-dom";
import "../css/top-nav.css";

const TopNav = () => {
  return (
    <div className="top-nav-root">
      <div className="top-nav-left">
        <div className="top-nav-location">
          <svg
            width="13"
            height="16"
            viewBox="0 0 13 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <g clipPath="url(#clip0_2_1575)">
              <path
                d="M9 6.01562C8.98 6.72229 8.74 7.31563 8.28 7.79563C7.8 8.25562 7.20667 8.49562 6.5 8.51562C5.79333 8.49562 5.2 8.25562 4.72 7.79563C4.26 7.31563 4.02 6.72229 4 6.01562C4.02 5.30896 4.26 4.71563 4.72 4.23563C5.2 3.77563 5.79333 3.53562 6.5 3.51562C7.20667 3.53562 7.8 3.77563 8.28 4.23563C8.74 4.71563 8.98 5.30896 9 6.01562ZM6.5 7.51562C6.92 7.49563 7.27333 7.34896 7.56 7.07562C7.83333 6.78229 7.98 6.42896 8 6.01562C7.98 5.59562 7.83333 5.24229 7.56 4.95562C7.27333 4.68229 6.92 4.53562 6.5 4.51562C6.08667 4.53562 5.73333 4.68229 5.44 4.95562C5.16667 5.24229 5.02 5.59562 5 6.01562C5.02 6.42896 5.16667 6.78229 5.44 7.07562C5.73333 7.34896 6.08667 7.49563 6.5 7.51562ZM12.5 6.01562C12.46 6.95563 12.1267 8.03896 11.5 9.26562C10.8533 10.4923 10.1233 11.679 9.31 12.8256C8.49667 13.9923 7.81 14.919 7.25 15.6056C7.04333 15.859 6.79333 15.9856 6.5 15.9856C6.20667 15.9856 5.95667 15.859 5.75 15.6056C5.19 14.919 4.49333 13.9923 3.66 12.8256C2.84667 11.679 2.12667 10.4923 1.5 9.26562C0.873333 8.03896 0.54 6.95563 0.5 6.01562C0.54 4.30896 1.12333 2.89229 2.25 1.76562C3.37667 0.638958 4.79333 0.055625 6.5 0.015625C8.20667 0.055625 9.62333 0.638958 10.75 1.76562C11.8767 2.89229 12.46 4.30896 12.5 6.01562ZM6.5 1.01562C5.08667 1.05562 3.91 1.54563 2.97 2.48563C2.03 3.41896 1.54 4.59562 1.5 6.01562C1.5 6.51562 1.67667 7.17229 2.03 7.98562C2.38333 8.81896 2.83333 9.68229 3.38 10.5756C3.92 11.449 4.47 12.2623 5.03 13.0156C5.59667 13.789 6.08667 14.4356 6.5 14.9556C6.92 14.4356 7.41 13.789 7.97 13.0156C8.53 12.2623 9.08333 11.449 9.63 10.5756C10.17 9.68229 10.6167 8.81896 10.97 7.98562C11.3233 7.17229 11.5 6.51562 11.5 6.01562C11.46 4.59562 10.97 3.41896 10.03 2.48563C9.09667 1.54563 7.92 1.05562 6.5 1.01562Z"
                fill="white"
              />
            </g>
            <defs>
              <clipPath id="clip0_2_1575">
                <rect
                  width="12"
                  height="15.9688"
                  fill="white"
                  transform="translate(0.5 0.015625)"
                />
              </clipPath>
            </defs>
          </svg>
          <p className="top-nav-location-text">
            Headquarters: Southern California, Serving: Nationwide
          </p>
        </div>
        <div className="top-nav-email">
          <svg
            width="17"
            height="16"
            viewBox="0 0 17 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <g clipPath="url(#clip0_2_1581)">
              <path
                d="M15.625 6C15.3117 6.02 15.145 6.18667 15.125 6.5V14.5C15.105 14.8133 14.9383 14.98 14.625 15H1.625C1.31167 14.98 1.145 14.8133 1.125 14.5V6.5C1.105 6.18667 0.938333 6.02 0.625 6C0.311667 6.02 0.145 6.18667 0.125 6.5V14.5C0.145 14.92 0.291667 15.2733 0.565 15.56C0.858333 15.8333 1.21167 15.98 1.625 16H14.625C15.045 15.98 15.3983 15.8333 15.685 15.56C15.9583 15.2933 16.105 14.95 16.125 14.53V6.5C16.105 6.18667 15.9383 6.02 15.625 6ZM2.155 8.62C2.155 8.66667 2.165 8.7 2.185 8.72C2.205 8.74 2.215 8.76 2.215 8.78C2.215 8.8 2.215 8.81 2.215 8.81C2.24167 8.83 2.275 8.85 2.315 8.87C2.315 8.89667 2.325 8.91 2.345 8.91L6.465 11.97C6.965 12.3033 7.51833 12.47 8.125 12.47C8.73167 12.47 9.285 12.2933 9.785 11.94L13.935 8.87C13.935 8.85 13.935 8.84 13.935 8.84C13.9817 8.82 14.015 8.8 14.035 8.78C14.035 8.74 14.045 8.71 14.065 8.69C14.085 8.67 14.095 8.63667 14.095 8.59C14.115 8.57 14.125 8.54 14.125 8.5C14.125 8.52 14.125 8.52 14.125 8.5V1.5C14.105 1.08 13.9583 0.726666 13.685 0.44C13.3983 0.166666 13.045 0.02 12.625 0H3.625C3.21167 0.02 2.85833 0.166666 2.565 0.44C2.29167 0.726666 2.145 1.08 2.125 1.5V8.5C2.125 8.5 2.125 8.51 2.125 8.53C2.125 8.57 2.135 8.6 2.155 8.62ZM3.125 1.5C3.145 1.18667 3.31167 1.02 3.625 1H12.625C12.9383 1.02 13.105 1.18667 13.125 1.5V8.25L9.185 11.16C8.85167 11.3867 8.49833 11.5 8.125 11.5C7.75167 11.5 7.39833 11.3867 7.065 11.16L3.125 8.25V1.5ZM11.125 7.47C11.105 7.15667 10.9383 6.99 10.625 6.97H5.625C5.31167 6.99 5.145 7.15667 5.125 7.47C5.145 7.76333 5.31167 7.92 5.625 7.94H10.625C10.9383 7.96 11.105 7.80333 11.125 7.47ZM5.625 4.97H10.625C10.9383 4.95 11.105 4.79333 11.125 4.5C11.105 4.20667 10.938 4.05 10.625 4.03H5.625C5.31167 4.05 5.145 4.20667 5.125 4.5C5.145 4.79333 5.31167 4.95 5.625 4.97Z"
                fill="white"
              />
            </g>
            <defs>
              <clipPath id="clip0_2_1581">
                <rect
                  width="16"
                  height="16"
                  fill="white"
                  transform="translate(0.125)"
                />
              </clipPath>
            </defs>
          </svg>
          <a
            className="top-nav-email-link"
            href="mailto:services@psenvironmental.com"
          >
            services@psenvironmental.com
          </a>
        </div>
        <div className="top-nav-phone">
          <Phone className="top-nav-phone-icon" />
          <a className="top-nav-phone-link" href="tel:2133289074">
            {" "}
            (213) 328-9074
          </a>
        </div>
      </div>
      <div className="top-nav-right">
        <Link target="_blank" to="/" className="top-nav-social-link">
          <BsTwitterX />
        </Link>
        <Link target="_blank" to="/" className="top-nav-social-link">
          <FaFacebookF />
        </Link>
        <Link target="_blank" to="/" className="top-nav-social-link">
          <FaLinkedinIn />
        </Link>
        <Link target="_blank" to="/" className="top-nav-social-link">
          <FaInstagram />
        </Link>
      </div>
    </div>
  );
};

export default TopNav;
